import { classNames } from '@helpers/classNames';
import ReactMarkdown from 'react-markdown';
import rehypeRaw from 'rehype-raw';
import remarkGfm from 'remark-gfm';

export default function MarkdownReader({ typography, markdown }) {
  const styles = Object.values(typography).join(' ');

  return (
    <article className="h-fit">
      <ReactMarkdown
        className={classNames('prose max-w-full px-4 lg:px-0', styles)}
        remarkPlugins={[remarkGfm]}
        rehypePlugins={[rehypeRaw]}
      >
        {markdown}
      </ReactMarkdown>
    </article>
  );
}
